'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _reactRouter = require('react-router');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _PasswordResetForm = require('./PasswordResetForm');

var _PasswordResetForm2 = _interopRequireDefault(_PasswordResetForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PasswordResetPage = (_dec = (0, _mobxReact.inject)('SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(PasswordResetPage, _Component);

  function PasswordResetPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PasswordResetPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordResetPage.__proto__ || Object.getPrototypeOf(PasswordResetPage)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'errorMessages', _descriptor, _this), _initDefineProp(_this, 'isSubmitting', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PasswordResetPage, [{
    key: 'onFormSubmit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isSubmitting) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                this.isSubmitting = true;
                this.errorMessages = [];

                if (!(data.new_password !== data.re_new_password)) {
                  _context.next = 8;
                  break;
                }

                this.errorMessages.push('Passwords do not match');
                this.isSubmitting = false;
                return _context.abrupt('return');

              case 8:
                _context.next = 10;
                return this.props.SessionStore.resetPassword(data);

              case 10:
                this.errorMessages = _context.sent;

                if (this.errorMessages.length === 0) {
                  _reactRouter.browserHistory.push({ pathname: '/accounts/login' });
                }
                this.isSubmitting = false;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onFormSubmit(_x) {
        return _ref2.apply(this, arguments);
      }

      return onFormSubmit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props$params = this.props.params,
          uid = _props$params.uid,
          token = _props$params.token;

      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true, className: 'page-login' },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            {
              lgOffset: 3, lg: 6,
              mdOffset: 3, md: 6,
              smOffset: 3, sm: 6,
              xsOffset: 1, xs: 10,
              className: 'wrapper-login'
            },
            _react2.default.createElement(
              'h1',
              null,
              'Please enter your new password'
            ),
            _react2.default.createElement(_PasswordResetForm2.default, {
              errorMessages: this.errorMessages,
              onFormSubmit: this.onFormSubmit,
              isSubmitting: this.isSubmitting,
              uid: uid,
              token: token
            })
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PasswordResetPage;
}(_react.Component), _class3.propTypes = {
  params: _propTypes2.default.shape({
    token: _propTypes2.default.string,
    uid: _propTypes2.default.string
  }),
  SessionStore: _propTypes2.default.object
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'errorMessages', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isSubmitting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = PasswordResetPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PasswordResetPage, 'PasswordResetPage', '/app/src/components/page-password-reset/PasswordResetPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-password-reset/PasswordResetPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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